import React, { useState } from 'react';
import { Card, Nav } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import TabProcessar from './components/TabProcessar';
import TabVerificarNaoLidos from './components/TabVerificarNaoLidos';
import TabConsultarRetornos from './components/TabConsultarRetornos';

const TABS = {
  processar: 'processar',
  naoLidos: 'naoLidos',
  consultar: 'consultar',
};

const RetornoCobranca = () => {
  const [tabAtiva, setTabAtiva] = useState(TABS.processar);

  return (
    <>
      <Header title="Retorno Cobrança - Geral" />
      <div className="container-fluid mt-3">
        <Card>
          <Card.Header>
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link
                  active={tabAtiva === TABS.processar}
                  onClick={() => setTabAtiva(TABS.processar)}
                >
                  Processar
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  active={tabAtiva === TABS.naoLidos}
                  onClick={() => setTabAtiva(TABS.naoLidos)}
                >
                  Arq. não Lidos
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  active={tabAtiva === TABS.consultar}
                  onClick={() => setTabAtiva(TABS.consultar)}
                >
                  Consultar Retornos
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body>
            {tabAtiva === TABS.processar && <TabProcessar />}
            {tabAtiva === TABS.naoLidos && <TabVerificarNaoLidos />}
            {tabAtiva === TABS.consultar && <TabConsultarRetornos />}
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default RetornoCobranca;
